import { HTTP } from "@/utils/http-common"

export default {
  async getAll($, projectId) {
    const path = `/projects/${projectId}/notifications`
    let results = (await HTTP.get(path)).data
    // results.sort((a, b) => {
    //   return a.name.localeCompare(b.name)
    // })
    return results
  },

  async get(actionId) {
    const path = `/projects/notifications/${actionId}`
    return (await HTTP.get(path)).data
  },

  async post(projectId, data) {
    const path = `/projects/${projectId}/notifications`
    return (await HTTP.post(path, data)).data
  },

  async put(data) {
    const { id, ...others } = data
    const path = `/projects/notifications/${id}`
    return (await HTTP.put(path, others)).data
  },

  async delete(actionId) {
    const path = `/projects/notifications/${actionId}`
    return (await HTTP.delete(path)).data
  }
}
